module.exports = __webpack_public_path__ + "static/media/ru.b1f80e78.svg";